export default __webpack_public_path__ + "static/media/my-volunteer-mockup-4.84ac27e4.png";